export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapParkingAreas';
export const ENTITY_EDIT_ROUTE = 'parking/areas/view';
